import { useEffect } from 'react';

interface UseLegalEntitiesEffectsProps {
  getLegalEntitiesHandler: () => Promise<void>;
}

export const useLegalEntitiesEffects = ({
  getLegalEntitiesHandler,
}: UseLegalEntitiesEffectsProps) => {
  useEffect(() => {
    getLegalEntitiesHandler();
  }, [getLegalEntitiesHandler]);
};
